<template>
    <el-container v-loading="isShowLoading">
        <el-main>
            <el-row>
                <el-col :span="24">
                    <el-form :model="filterData" :inline="true" size="small">
                        <el-form-item label="开票日期:">
                            <el-date-picker v-model="filterData.createDate" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels
                                range-separator="-" start-placeholder="开票日期起" end-placeholder="开票日期止" style="width: 240px;"
                                :picker-options="pickerOptions">
                                </el-date-picker>
						</el-form-item>
                        <el-form-item>
                            <el-select v-model="filterData.einvoiceTypeCode" placeholder="票据种类" clearable >
                                <el-option v-for="item in einvoiceTypeOptions" :key="item.einvoiceTypeName" :label="item.einvoiceTypeName" :value="item.einvoiceTypeCode" >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filterData.einvoiceCode" placeholder="票据代码" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filterData.einvoiceNumber" placeholder="票据号码" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filterData.serialNumber" placeholder="业务流水号" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filterData.payerPartyName" placeholder="交款人名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="filterData.einvoiceStatus" placeholder="开票状态" clearable >
                                <el-option v-for="item in einvoiceStatusOptions" :key="item.value" :label="item.value" :value="item.key" >
                                </el-option>
                            </el-select>
                        </el-form-item>
                         <el-form-item>
                            <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
                </el-col>
            </el-row>

            <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :row-style="{height:'30px'}" :height="tableHeight" @row-dblclick="onRowDblclick"
                :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <!-- <el-table-column type="index" width="50" label="序号"></el-table-column> -->
                <!-- <el-table-column property="agencyCode" label="选择" align="center">
                    <template slot-scope="scope">
                        <el-radio :label="scope.$index+1" v-model="radio" @change.native="getCurrentRow(scope.row)"></el-radio>
                    </template>
                </el-table-column> -->
                <el-table-column type="index" width="70" label="序号" align="center"></el-table-column>
                <el-table-column property="weaveTime" label="编制日期" width="160"></el-table-column>
                <el-table-column property="einvoiceTypeName" label="票据名称" width="190" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="einvoiceCode" label="票据代码" width="100" align="center"></el-table-column>
                <el-table-column property="einvoiceNumber" label="票据号码" width="100" align="center"></el-table-column>
                <el-table-column property="randomNumber" label="校验码" width="80" align="center"></el-table-column>
                 <el-table-column property="einvoiceMode" label="开票类型" width="100" align="center">
                     <template slot-scope="scope">
                        <div v-if="scope.row.einvoiceMode == '0'">正常票</div>
                        <div v-if="scope.row.einvoiceMode == '1'">红票</div>
                        <div v-if="scope.row.einvoiceMode == '2'">被红冲票</div>
                    </template>
                </el-table-column>
                <el-table-column property="einvoiceStatus" label="开票状态" width="100" align="center">
                     <template slot-scope="scope">
                        <div v-if="scope.row.einvoiceStatus == '0'">保存</div>
                        <div v-if="scope.row.einvoiceStatus == '1'">开具成功</div>
                        <div v-if="scope.row.einvoiceStatus == '2'">开具失败</div>
                        <div v-if="scope.row.einvoiceStatus == '3'">开具中</div>
                    </template>
                </el-table-column>
                <el-table-column property="totalAmount" label="开票金额" width="100"></el-table-column>
                <el-table-column property="einvoiceSourceCode" label="票据来源" width="100" align="center"></el-table-column>
                <el-table-column property="payerPartyName" label="交款人" width="100" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="responseCode" label="开票代码" width="80" align="center"></el-table-column>
                <el-table-column property="responseMsg" label="开票结果" width="220">
                    <template slot-scope="scope">
                        <div class="dt" @click="columnDeal(scope.row.responseMsg)" >
                            {{scope.row.responseMsg}}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                        @pagination="onFilter" />
                </el-col>
            </el-row>

            <div style="height: 60px"></div>
            <el-drawer :visible.sync="layout.edit" :show-close="false" :wrapperClosable="false" :withHeader="false"
                :size="pageWidth + 'px'" direction="rtl" custom-class="demo-drawer" style="top: 67px">
                <div class="demo-drawer-content">
                    <Entity v-if="layout.edit" @back="back" @reload="onFilter" v-bind:entity="entityData" ref="itemPanel"></Entity>
                </div>
            </el-drawer>
        </el-main>
    </el-container>
</template>

<script>
    import Entity from "./Entity.vue"

    let _kits, _table
    export default {
        components: {
            Entity
        },
        data() {
            return {
                radio: "",
                einvoiceTypeOptions:[],
                einvoiceSkfsOptions:[],
                einvoiceStatusOptions:[],
                templateSelection: {},
                isShowLoading: true, 
                isShowItem: false,
                pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                pickerOptions: {
                    onPick: ({
                        maxDate,
                        minDate
                    }) => {
                        this.selectDate = minDate.getTime();
                        if (maxDate) {
                            this.selectDate = ''
                        }
                    },
                    disabledDate: (time) => {
                        if (this.selectDate !== '') {
                            const one = 30 * 24 * 3600 * 1000;
                            const minTime = this.selectDate - one;
                            const maxTime = this.selectDate + one;
                            return time.getTime() < minTime || time.getTime() > maxTime
                        }
                    }
                },
                //数据绑定相关
                filterData: {
                    agencyCode:"",
                    placeCode:"",
                    organDm: "",
                    organName: "",
                    agencyName: "",
                    agencyType:"",
                    areaName: "",
                    areaDm:"",
                    isValid:"",
                    createDate:this.$defaultEinv
                }, //过滤信息
                recordData: [], //展示信息
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                entityData: {} //具体某一项信息
            }
        },
        methods: {
            onAdd() {
                this.layout.edit = true
                this.entityData = {
                    agencyCode: this.filterData.agencyCode, 
                    agencyName: this.filterData.agencyName, 
                    placeCode: this.filterData.placeCode
                }
            },
            onRowDblclick(row, column, event) {
                console.log(row)
            },
            updateAgency() {
                if (this.checkSelect()) {
                    return;
                }
                this.entityData = {
                    agencyCode: this.templateSelection.agencyCode
                };
                this.layout.edit = true;
            },
            checkSelect() {
                if (this.templateSelection.agencyCode == undefined) {
                    this.$alert("请先选择一条记录");
                    return true;
                }
                return false;
            },
            onFilter() {
                var createDate = this.filterData.createDate;
                if(createDate!= null &&
                    createDate != undefined ){
                    this.filterData.createDate = createDate.toString();
                }
                if((createDate == null || createDate == undefined) && 
                  ((this.filterData.serialNumber == "" || this.filterData.serialNumber == undefined) && 
                   (this.filterData.einvoiceNumber == "" || this.filterData.einvoiceNumber == undefined) && 
                   (this.filterData.einvoiceStatus == "" || this.filterData.einvoiceStatus == undefined || this.filterData.einvoiceStatus == "1"))){
                    alert("只有票据号码、或业务流水号不为空或开票状态不是开具成功的情况下日期条件才允许输入空,查询全部");
                    return;
                }
                this.layout.loading = true
                _table.load()
                if(createDate!= null &&
                    createDate != undefined ){
                    this.filterData.createDate = createDate.toString().split(",");
                }
            },
            init() {
                this.radio = "";
                _table.load()
            },
            back() {
                //console.log("back")
                this.layout.edit = false
            }
        },
        created() {
            this.pageWidth = window.innerWidth - 200
            _kits = this.$kits()
            _kits.api.call(
                "QUERYEINVOICETYPEBYUSER", {},
                result => {
                    if (result.returnCode == "0000") {
                        this.einvoiceTypeOptions = result.data.einvoiceTypeList;
                        this.einvoiceSkfsOptions = result.data.einvoiceSkfs;
                        this.einvoiceStatusOptions = result.data.einvoiceStatus;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            var createDate = this.filterData.createDate;
            if(createDate!= null &&
                createDate != undefined ){
                this.filterData.createDate = createDate.toString();
            }
            _table = _kits.table(
                "GETUSERPLACEEINVLIST",
                () => {
                    this.isShowLoading = true;
                    return Object.assign({}, this.filterData, this.pagination)
                },
                result => {
                    this.isShowLoading = false
                    this.recordData = result.list
                    this.pagination.total = Number.parseInt(result.total)
                    this.filterData.agencyCode = result.agencyCode
                    this.filterData.placeCode = result.placeCode
                    this.filterData.agencyName = result.agencyName
                }
            )
            
            this.init()
            if(createDate!= null &&
                createDate != undefined ){
                this.filterData.createDate = createDate.toString().split(",");
            }
        },
        mounted() {}
    }
</script>
<style scoped>
</style>
